// File: client/src/components/analytics/ScoreWheel.js
import React from 'react';
import { getScoreColor } from './scoreUtils';

function ScoreWheel({ value = 0, label = '', displayAsPercentage = true, maxValue = 100 }) {
    // Calculate percentage for visual representation (always 0-100 for fill)
    const percentage = Math.min(100, Math.max(0, (value / maxValue) * 100));
    const { gradient } = getScoreColor(percentage);
    const gradientId = `scorewheel-${label.replace(/\s+/g, '')}-${Math.round(percentage)}`;

    // Determine display value based on toggle
    const displayValue = displayAsPercentage ? `${percentage.toFixed(1)}%` : value.toFixed(1);

    return (
        <div
            style={{
                position: 'relative',
                width: '180px',
                height: '180px',
                margin: '20px auto 30px',
            }}
        >
            <svg
                viewBox="0 0 36 36"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    transform: 'rotate(-90deg)',
                }}
            >
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor={gradient[0]} />
                        <stop offset="100%" stopColor={gradient[1]} />
                    </linearGradient>
                </defs>
                <circle
                    cx="18"
                    cy="18"
                    r="16"
                    fill="none"
                    stroke="#f3f4f6"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                <circle
                    cx="18"
                    cy="18"
                    r="16"
                    fill="none"
                    stroke={`url(#${gradientId})`}
                    strokeWidth="3"
                    strokeDasharray={`${percentage * 1.01}, 100`}
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dasharray 0.5s ease' }}
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#111827',
                        marginBottom: '8px',
                    }}
                >
                    {displayValue}
                </div>
                <div
                    style={{
                        fontSize: '14px',
                        color: '#6b7280',
                        padding: '0 10px',
                    }}
                >
                    {label}
                </div>
            </div>
        </div>
    );
}

export default ScoreWheel;
